import { LibrarySkeleton } from '@/components/Library/LibrarySkeleton';
import { VIDEO_TILE_WIDTH } from '@/components/VideoTile';
import { AvatarTile, isUserAvatar } from '@/pages/avatar';
import { DeleteAvatarModal } from '@/pages/avatar/ListPage/components';
import { ModerationModal } from '@/pages/editor/layout/ModerationModal';
import { SectionTitle } from '@/pages/home/components/Common';
import { AppRoutes } from '@/utils/types';
import { Presenter } from '@d-id/types';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useVideoDisplayLimit } from '../../hooks/useVideoDisplayLimit';
import {
    WorkspaceSectionContainer,
    WorkspaceSectionHeader,
    WorkspaceSectionHeaderButton,
    WorkspaceTileList,
} from '../workspaceComponents/common';

interface IProps {
    avatars: Presenter[];
    isLoading: boolean;
}

export const MyAvatars = ({ avatars, isLoading }: IProps) => {
    const navigate = useNavigate();
    const ref = useRef<HTMLDivElement | null>(null);

    const limit = useVideoDisplayLimit(ref, avatars.length);
    const elements = [...avatars].splice(0, limit);
    const showSeeAll = avatars.length > elements.length;

    if (isLoading) {
        return (
            <WorkspaceSectionContainer>
                <WorkspaceSectionHeader>
                    <SectionTitle id="avatars-section">Avatars</SectionTitle>
                </WorkspaceSectionHeader>
                <LibrarySkeleton amount={4} tileHeight="260px" tileWidth={`${VIDEO_TILE_WIDTH}px`} />
            </WorkspaceSectionContainer>
        );
    }

    if (!avatars?.length) {
        return null;
    }

    return (
        <>
            <WorkspaceSectionContainer>
                <WorkspaceSectionHeader>
                    <SectionTitle id="avatars-section">Avatars</SectionTitle>
                    {showSeeAll && (
                        <WorkspaceSectionHeaderButton onClick={() => navigate(AppRoutes.Avatars)}>See all</WorkspaceSectionHeaderButton>
                    )}
                </WorkspaceSectionHeader>

                <WorkspaceTileList ref={ref}>
                    {elements.map(avatar => (
                        <AvatarTile
                            key={avatar.id}
                            avatar={avatar}
                            isAiGenerated={!!avatar.is_aiGenerated}
                            editable={isUserAvatar(avatar)}
                        />
                    ))}
                </WorkspaceTileList>
            </WorkspaceSectionContainer>

            <ModerationModal />
            <DeleteAvatarModal />
        </>
    );
};
